import { HttpError } from '@/common/infrastructure/http/problemDetails';

const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === 'object' && value !== null;

/**
 * A log-safe summary of a failed variable-catalog fetch: the message and, when present, the HTTP
 * status. Never the raw error - an Axios error carries the request config, including the Bearer header.
 */
export const describeCatalogFailure = (error: unknown): { message: string; status?: number } => {
  // The API client rejects with `HttpError` (no `.response`); read its status first.
  if (error instanceof HttpError) return { message: error.message, status: error.status };
  if (!isRecord(error)) return { message: 'Unknown error' };
  const message = typeof error.message === 'string' ? error.message : 'Unknown error';
  const response = error.response;
  const status = isRecord(response) && typeof response.status === 'number' ? response.status : undefined;
  return status === undefined ? { message } : { message, status };
};
